import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: "Audit Events", value: "AUDIT_EVENTS" },
    { label: "Item Usages", value: "ITEM_USAGES" },
    { label: "Sign In Attempts", value: "SIGN_IN_ATTEMPTS" }
  ];
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      if (contentTypes.length === 0) {
        setLogTypeVal(true);
        return;
      }
      onSubmit();
    } else {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "The Polling Interval must be greater than 1 minute."
      });
    }
    formData.contentTypes.value = contentTypes;
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Proceed",
      title: "",
      className: "col-md-7",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contentTypes" }, "Content Types to Collect"),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "contentTypes",
        id: "contentTypes",
        onChange: (selected) => setContentTypes(selected),
        options: availableContent,
        value: contentTypes
      }
    ),
    logTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes", style: { color: "red" } }, "Select at least one Log Type"),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The events for the above content types will be fetched."),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: "Determines how often (in minutes) the input will check for new data from 1Password. The smallest allowable interval is 1 minute.",
        label: "Polling Interval Minutes"
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
